export const ENUM_PRODUCT_ID_BY_NAME = {
  GASOLINA_COMUM: "4807d465-24f7-4f34-bb92-1d359e3230b3",
  GASOLINA_ADITIVADA: "74c075c9-f4bc-4604-ba0e-7f90028a40ce",
  GNV: "ddf116bb-77c3-4c6e-8f08-595107e2e7e8",
  DIESEL_S10: "98469550-615e-436e-a48a-fdfd3798b3a2",
  DIESEL_S500: "07a7fa9e-e0d1-40f4-91bd-a2e7c2872072",
  ETANOL_HIDRATADO: "9d6d21ad-0dee-4f61-8e66-377f63257a2e",
  OUTRO: "546d7993-68d3-4163-9590-c62c74557b77",
};
